module.exports = __webpack_public_path__ + "static/lhcpapclogoonly-6f839bc28eb3f829179a49b6354cd55a.jpg";